import { Pipe, PipeTransform } from '@angular/core';
import { TableImageType } from '@model/tables-plan';

@Pipe({
  name: 'uniqueTableTypes',
})
export class UniqueTableTypesPipe implements PipeTransform {

  transform(value: TableImageType[], ...args: unknown[]): TableImageType[] {
    return [... new Set(value)];
  }

}

@Pipe({
  name: 'filterByTableType',
})
export class FilterByTableTypePipe implements PipeTransform {

  transform(value: TableImageType[], ...args: unknown[]): TableImageType[] {
    const tableType: TableImageType = args[0] as TableImageType;
    const category: { covers: number, tableTypes: TableImageType[] } = args[1] as { covers: number, tableTypes: TableImageType[] };
    console.log(category.tableTypes.filter(t => t === tableType));
    return value.filter(t => t === tableType);
  }

}
